import React from 'react';
import getDaysForMonthlyDisplay from '../../utils/getDaysForMonthlyDisplay';
import './style.css';

const MonthlyCalendar = (props) => {
  let { initYear, initMonth } = props;

  // if there are no arguments supplied we will show the current year and month
  if (!initYear || !initMonth) {
    let today = new Date();
    let year = today.getFullYear();
    let month = today.getMonth();
    initYear = year;
    initMonth = month;
  }

  const [ year, setYear ] = React.useState(Number(initYear));
  const [ month, setMonth ] = React.useState(Number(initMonth));

  const daysArray = getDaysForMonthlyDisplay(Number(year), Number(month));
  const rows = daysArray.length / 7;

  const dayNames = [
    'Ned', 'Pon', 'Uto', 'Sre', 'Cet', 'Pet', 'Sub'
  ]

  const monthNames = [
    'Januar', 'Februar', 'Mart', 'April', 'Maj', 'Juni',
    'Juli', 'Avgust', 'Septembar', 'Oktobar', 'Novembar', 'Decembar'
  ]

  // console.log(rows);

  // have to split the array by weeks for easier rendering
  let weeks = [];
  let week = [];

  for (let ix = 0; ix < daysArray.length; ix++) {
    week.push(daysArray[ix]);

    if (ix % 7 === 6) {
      weeks.push([...week]);
      week = [];
    }
  }

  const onMonthPrevious = (e) => {
    let prevMonth = month > 0 ? month - 1 : 11;
    let prevYear = month > 0 ? year : year - 1;
    setMonth(prevMonth);
    setYear(prevYear);
  }

  const onMonthNext = (e) => {
    let nextMonth = month < 11 ? month + 1 : 0;
    let nextYear = month < 11 ? year : year + 1;
    setMonth(nextMonth);
    setYear(nextYear);
  }

  return (
    <table>
      <thead>
        <tr>
          <th colSpan='8'>
            {year}
          </th>
        </tr>
        <tr>
          <th
            style={{ cursor: 'pointer' }}
            onClick={onMonthPrevious}
          >&lt;</th>
          <th colSpan='6'>
            {monthNames[month]}
          </th>
          <th
            style={{ cursor: 'pointer' }}
            onClick={onMonthNext}
          >&gt;</th>
        </tr>
        <tr>
          <th>
            Wk
          </th>
          <th>
            {dayNames[1]}
          </th>
          <th>
            {dayNames[2]}
          </th>
          <th>
            {dayNames[3]}
          </th>
          <th>
            {dayNames[4]}
          </th>
          <th>
            {dayNames[5]}
          </th>
          <th>
            {dayNames[6]}
          </th>
          <th>
            {dayNames[0]}
          </th>
        </tr>
      </thead>
      <tbody>
        {weeks.map((week, ix) => {

          // get relevant week..
          let weekOfTheYear = week.find(day => day.month === month).weekOfTheYear;

          return (
            <tr key={ix}>
              <th>{weekOfTheYear}</th>
              {week.map((day, i) => {
                return (
                  <td
                    key={i}
                    className={day.month === Number(month) ? 'day-active' : 'day-inactive'}
                  >
                    <span>{day.day}</span>
                  </td>
                )
              })}
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}

export default MonthlyCalendar
